export default {
  "models.orderUnit.ean": "GTIN (EAN) der Versandeinheit",
  "models.orderUnit.edmNumber": "EDM Nummer",
  "models.orderUnit.name": "Name der Bestelleinheit",
  "models.orderUnit.netPriceCents": "Einkaufspreis",
  "models.orderUnit.orderUnitType": "Platzierung",
  "models.orderUnit.shippingUnitDepositType": "Pfandart",
  "models.orderUnit.shippingUnitDepositValueCents": "Pfandwert",
  "models.orderUnit.shippingUnitGrossWeight": "Bruttogewicht",
  "models.orderUnit.shippingUnitHeight": "Höhe",
  "models.orderUnit.shippingUnitLength": "Länge",
  "models.orderUnit.shippingUnitNetWeight": "Nettogewicht",
  "models.orderUnit.shippingUnitPackaging": "Verpackungsart",
  "models.orderUnit.shippingUnitWidth": "Breite",
  "models.orderUnit.supplierArticleNumber": "Lieferantenartikelnummer",
  "models.orderUnit.validFrom": "Bestellbar ab",
  "models.orderUnit.validUntil": "Bestellbar bis",
  "models.orderUnit.orderableFromBeforeOrderableTo": "Bestellbar ab",
  "models.orderUnit.orderableToMustBeInTheFuture": "Bestellbar bis",
  "models.orderUnit.vat": "Umsatzsteuer",
};
